import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from '@ui5/webcomponents-react'; // Update the import statement


import "./index.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import App from "./pages/App/App";
import { OCRContextProvider } from "./context/ocr-context";
import { UserContextProvider } from "./context/user-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider> {/* Wrap your App with ThemeProvider */}
        <UserContextProvider>
          <OCRContextProvider>
            <BrowserRouter>
              <SnackbarProvider maxSnack={3}>
                <App />
              </SnackbarProvider>
            </BrowserRouter>
          </OCRContextProvider>
        </UserContextProvider>
    </ThemeProvider>,
);

